
function generateGlossary(glossary) {
  glossary.querySelector('.glossary-index').setAttribute('id', 'glossary-index');
  const elements = glossary.querySelectorAll('.glossary-js');
  const headlines = [];
  elements.forEach((e) => {
    const hl = e.querySelector('.teaser__headline .headline');
    const currentHeadline = {
      text: hl.textContent,
      id: e.id,
    };
    headlines.push(currentHeadline);
  });
  const filteredHeadlines = headlines.filter((hl, index, array) => {
    const firstLetters = array.map(element => element.text.substr(0, 1));
    const firstHeadlineLetter = hl.text.substr(0, 1);
    return (firstLetters.indexOf(firstHeadlineLetter) === index);
  });

  const glossaryIndexListItems = glossary.querySelectorAll('.glossary-index__list-item a');
  glossaryIndexListItems.forEach((item) => {
    filteredHeadlines.forEach((hl) => {
      if (item.textContent === hl.text.substr(0, 1)) {
        item.setAttribute('href', `#${hl.id}`);
        item.setAttribute('data-scroll', 'true');
      }
    });
  });
}

document.querySelectorAll('.glossary').forEach(e => generateGlossary(e));
document.querySelectorAll('.glossary-index__list-item .link').forEach((linkItem) => {
  const hasHeadline = linkItem.getAttribute('href').length > 1;
  if (hasHeadline) linkItem.classList.remove('glossary-index__list-item--inactive');
});

document.querySelectorAll('.link--top-glossary').forEach(($toplink) => {
  $toplink.setAttribute('href', '#glossary-index');
  $toplink.setAttribute('data-scroll', 'true');
});



// WEBPACK FOOTER //
// ./src/components/organisms/glossary/glossary.js